import useCurrentUser from "hooks/useCurrentUser"

function usePayingUser() {
  const user = useCurrentUser()
  return user?.subscription?.product_name === "Básico" || user?.subscription?.product_name === "Profissional"
}

export default usePayingUser
